import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import preloadOperationsQueryNode from './__generated__/preloadOperationsQuery.graphql.ts';

export async function preloadOperations() {
	const { userId } = getPreloaderFnContext();
	if (!userId) {
		return;
	}

	return query({ query: preloadOperationsQueryNode });
}
